export default "__VITE_ASSET__D0_tP$PS__"